import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot,
         ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { map, take } from 'rxjs/operators';

import { SearchFilterService } from '../services/search-filter.service';
import { CodeNamePair } from '../../model/code-name-pair.model';

@Injectable()
export class SearchOperatorsResolver implements Resolve<CodeNamePair[]> {
  constructor(
    private searchFilterService: SearchFilterService,
    private router: Router
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CodeNamePair[]> {

    return this.searchFilterService.getSearchOperators().map(operators => {
      if (operators) {
        return operators;
      } else {
        this.router.navigate(['/']);
        return null;
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-list/resolvers/search-operators.resolver.ts